import React, { useState } from "react";
import { Card, Checkbox, Input, Radio } from "antd";
import styles from "../styles/BusinessInfo.module.css";
import { useItemsFine } from "../../_actions/app/items";
import classNames from "classnames"; // If available, or use template literals

export default function IndustryInfo({ answers, onAnswerChange }) {
    const { isSuccess, loading, data, meta } = useItemsFine(
        "qdb_industry",
        "limit=-1&fields=id,name",
        true
    );

    const industries = React.useMemo(() => {
        if (!data) return [];

        // Map API data to option format
        const options = data.map((industry) => ({
            id: industry.id,
            name: industry.name,
        }));

        // Add "other" option at the end
        return [...options];
    }, [data]);

    const [otherBusinessModel, setOtherBusinessModel] = useState(
        answers.otherBusinessModel || ""
    );

    // Handle industry selection
    const handleIndustryChange = (industryId) => {
        onAnswerChange("industry", industryId);
    };

    // Handle business model selection - Change to single selection
    const handleBusinessModelChange = (model) => {
        // If the same model is clicked again, deselect it

        onAnswerChange("businessModel", model);
    };

    const businessModels = [
        {
            key: "B2B",
            title: "Companies or businesses",
            description: "B2B - Your customers are primarily other businesses",
            image: "/images_rte/B2B.png",
        },
        {
            key: "B2C",
            title: "Regular people buying for themselves",
            description: "B2C - You sell directly to individual consumers",
            image: "/images_rte/B2C B2B.png",
        },
        {
            key: "B2B_B2C",
            title: "A mix of both",
            description: "You serve both businesses and individual consumers",
            image: "/images_rte/B2C.png",
        },
    ];

    const businessModelsNew = [
        {
            key: "B2B",
            title: "Companies or businesses",
            icon: "fas fa-building",
            description: "B2B - Your customers are primarily other businesses",
            image: "/images_rte/B2B.png",
        },
        {
            key: "B2C",
            title: "Regular people",
            icon: "fas fa-users",
            description: "B2C - You sell directly to individual consumers",
            image: "/images_rte/B2C B2B.png",
        },
        {
            key: "B2B_B2C",
            title: "A mix of both",
            icon: "fas fa-industry",
            description: "You serve both businesses and individual consumers",
            image: "/images_rte/B2C.png",
        },
    ];

    // Check if a card is selected - Updated for single selection
    const isBusinessModelSelected = (model) => {
        return answers.businessModel === model;
    };
    const isIndustrySelected = (industryId) => {
        return answers.industry === industryId;
    };

    return (
        <div className={styles.slideContent}>
            <div className={classNames(styles.questionsContainer, styles.questionGroupContainer)}>
                {/* First question - Industry */}
                <div className={styles.questionGroup}>
                    <label className={styles.slideTitle}>
                        Organization Name
                    </label>
                    <Input
                        style={{ marginTop: "15px" }}
                        placeholder="Organization Name"
                        value={answers.name || ""}
                        onChange={(e) => onAnswerChange("name", e.target.value)}
                    />
                </div>

                <div className={styles.questionGroup}>
                    <label className={styles.slideTitle}>
                        Pick your Industry
                    </label>
                    {/* <h3>Pick your Industry</h3> */}
                    <div className={styles.industryGrid}>
                        {industries.map((industry) => (
                            <div
                                key={industry.id}
                                className={classNames(
                                    styles.industryItem,
                                    isIndustrySelected(industry.id) && styles.industryItemSelected
                                )}
                                onClick={() => handleIndustryChange(industry.id)}
                            >
                                {industry.name}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Second question - Business Model as Cards */}
                <div className={styles.questionGroup}>
                    <label className={styles.slideTitle}>
                        Are your customers mostly...?
                    </label>


                    <div className={styles.businessModelContainer}>
                        {businessModelsNew.map((model) => (
                            <Card
                                key={model.key}
                                hoverable
                                className={classNames(
                                    styles.businessModelCard,
                                    isBusinessModelSelected(model.key) && styles.businessModelCardSelected
                                )}
                                style={{ textAlign: "center" }}
                                cover={<i className={model.icon} style={{
                                    fontSize: "50px",
                                    color: "#90dcc5ff",
                                    paddingTop: "20px"
                                }}></i>}
                                onClick={() => handleBusinessModelChange(model.key)}
                            >
                                <Card.Meta
                                    title={model.title}
                                    description={model.description}
                                />
                            </Card>
                        ))}
                    </div>

                    {/* <div className={styles.businessModelContainer}>
                        {businessModels.map((model) => (
                            <Card
                                key={model.key}
                                hoverable
                                className={classNames(
                                    styles.businessModelCard,
                                    isBusinessModelSelected(model.key) && styles.businessModelCardSelected
                                )}
                                cover={
                                    <img
                                        alt={model.title}
                                        src={model.image}
                                        className={styles.businessModelImage}
                                    />
                                }
                                onClick={() => handleBusinessModelChange(model.key)}
                            >
                                <Card.Meta
                                    title={model.title}
                                    description={model.description}
                                />
                            </Card>
                        ))}
                    </div> */}
                </div>
            </div>
        </div>
    );
}
